import ithacaLogo from '../../assets/ithaca-logo.png';
import hashlockLogo from '../../assets/hashlock_logo.svg';

function Footer() {
  return (
    <div className="mx-auto mt-auto w-full max-w-screen-xl px-6 md:px-10">
      <div className="flex flex-col pb-6 md:flex-row md:justify-between">
        <div className="mb-4 flex items-center gap-2 md:mb-0">
          <h1 className="text-gray-2">Powered by</h1>
          <img src={ithacaLogo} alt="logo" className="h-16" />
        </div>

        <div className="flex items-start gap-4 md:items-end">
          <div className="flex flex-col gap-2">
            <span className="block text-sm text-gray-400">Audited by</span>
            <a
              href="https://hashlock.com"
              target="_blank"
              rel="noopener noreferrer"
              className="block transition-opacity hover:opacity-80"
            >
              <img src={hashlockLogo} alt="HashLock" className="h-6" />
            </a>
          </div>

          <div className="flex flex-col gap-2">
            <a
              href="https://hashlock.com/wp-content/uploads/2024/10/Ithaca-Token-Racer-Smart-Contract-Audit-Report-Final-Report-v2.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 text-sm text-purple-400 transition-colors hover:text-purple-300"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Smart Contract Audit
            </a>

            <a
              href="https://hashlock.com/wp-content/uploads/2024/10/Ithaca-Token-Publisher-Penetration-Test-Report-Final-Report-v2.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 text-sm text-purple-400 transition-colors hover:text-purple-300"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Publisher Penetration Test
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
